import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, ExternalLink } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Excelente trato y eficiencia de verdad muy profesional, Dios les bendiga siempre',
    author: 'Jose Alonso Calderon Morales',
    initials: 'JC',
    link: 'https://www.facebook.com/Ingenieria.Jazuga/reviews/?id=100070574271417&sk=reviews'
  }, {
    quote: 'Excelente y pronto servicio. Super recomendados.',
    author: 'Milena Durán',
    initials: 'MD',
    link: 'https://www.facebook.com/Ingenieria.Jazuga/reviews/?id=100070574271417&sk=reviews'
  }, {
    quote: 'Instalación rápida y certificación después de agendado el día acordado se hizo el trabajo',
    author: 'Alexis González',
    initials: 'AG',
    link: 'https://www.facebook.com/Ingenieria.Jazuga/reviews/?id=100070574271417&sk=reviews'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-340">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-341">
        <div className="text-center mb-16" data-id="element-342">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4" data-id="element-343">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-xl text-gray-600" data-id="element-344">
            Opiniones reales de clientes satisfechos en Facebook.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-345">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 relative" data-id="element-346">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-blue-100" data-id="element-347" />

              <div className="flex gap-1 mb-6" data-id="element-348">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 text-[#f59e0b] fill-current" data-id="element-349" />)}
              </div>

              <p className="text-gray-700 text-lg mb-8 italic relative z-10" data-id="element-350">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center justify-between" data-id="element-351">
                <div className="flex items-center gap-4" data-id="element-352">
                  <div className="w-12 h-12 bg-[#1e3a5f] rounded-full flex items-center justify-center text-white font-bold text-lg" data-id="element-353">
                    {testimonial.initials}
                  </div>
                  <div data-id="element-354">
                    <h4 className="font-bold text-gray-900" data-id="element-355">
                      {testimonial.author}
                    </h4>
                    <p className="text-sm text-gray-500" data-id="element-356">Cliente verificado</p>
                  </div>
                </div>
                <a href={testimonial.link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 transition-colors" title="Ver reseña en Facebook" data-id="element-357">
                  <ExternalLink className="w-5 h-5" data-id="element-358" />
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}